import { DEMO_ROLE_KEY, type DemoRole } from './constants';

/**
 * Single source of truth for "is the demo running, and as whom".
 *
 * sessionStorage rather than localStorage is deliberate: a demo belongs to the
 * tab it was opened in. Closing it ends the demo, and a visitor never returns
 * days later to a half-finished negotiation they don't remember starting.
 *
 * Every read is wrapped: sessionStorage throws outright in some privacy modes,
 * and a demo that cannot start must degrade to the real app rather than to a
 * blank page.
 */

const isRole = (v: unknown): v is DemoRole => v === 'rider' || v === 'driver';

export function getDemoRole(): DemoRole | null {
  try {
    const raw = globalThis.sessionStorage?.getItem(DEMO_ROLE_KEY);
    return isRole(raw) ? raw : null;
  } catch {
    return null;
  }
}

export function isDemoSession(): boolean {
  return getDemoRole() !== null;
}

export function setDemoRole(role: DemoRole): void {
  try {
    globalThis.sessionStorage?.setItem(DEMO_ROLE_KEY, role);
  } catch {
    /* Private mode with storage disabled: the caller's state still drives the
       current page, the demo just will not survive a reload. */
  }
}

export function clearDemoSession(): void {
  try {
    globalThis.sessionStorage?.removeItem(DEMO_ROLE_KEY);
  } catch {
    /* nothing to do */
  }
}
